<template>
  <div class='h100-40 width-100vw h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='monitorServiceProcessData' :contextMenuItems="contextMenuItems" :contextMenuOpen='menuBeforeOpenFunc' :contextMenuClick='menuClickFunc'
              :selectionSettings='selectionOptions' :allowReordering='true' :allowResizing='true' >
      <e-columns>
        <e-column type='checkbox' textAlign='Center' width='66'></e-column>
        <e-column field='componentName' :headerText='$t("Topo.service") + $t("DeployManagement.type")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='state' :headerText='$t("DeployManagement.runStatus")' :disableHtmlEncode='false' :formatter='formatActiveState' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='description' :headerText='$t("MCS.description")' textAlign='Center' minWidth='10' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='activeTime' :headerText='$t("Monitor.systemLog.productStart")' textAlign='Center' minWidth='10' type='date' :format='dateFormatOptions' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='unactiveTime' :headerText='$t("Pm.hangupTime")' textAlign='Center' minWidth='10' type='date' :format='dateFormatOptions' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager ref='pager' @click='getMonitorServiceProcessListData' :currentPage='page.pageNo' :pageSize='page.pageSize' :totalRecordsCount='page.totalCount' :pageCount='page.pageCount'></ejs-pager>
  </div>
</template>

<script>
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: "monitorServiceProcessTable",
  data() {
    return {
      selectionOptions: { type: 'Multiple' },
      dateFormatOptions: { type: 'date', format: 'yyyy-MM-dd HH:mm:ss' },
      contextMenuItems: [{
        text: `${this.$t('Alarm.refresh')}`
      }, {
        text: `${this.$t('Monitor.systemLog.startup')}`
      }, {
        text: `${this.$t('Monitor.systemLog.shutdown')}`
      }],
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 3,
        pageCount: 1
      },
      monitorServiceProcessData: [],
    }
  },
  methods: {
    formatActiveState(grids, data) {
      let color = '';
      switch (data.state) {
        case 'down':
          color = 'red';
          break;
        case 'up':
          color = 'green';
          break;
        case 'exception':
          color = 'orange';
          break;
        default:
          break;
      }
      return `<span style='background-color:${color};font-size: 12px;display: inline-block;width: 55px;height: 22px;color: #fff;line-height: 22px;' >${data.state}</span>`;
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.no_checked')});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Common.tips.onlyOneSelect')});
        return false;
      }
      return selectedRecords;
    },
    getCheckedVals() {
      const ids = [];
      const checkedData = this.getCheckedData(true);
      for (let i = 0; i < checkedData.length; i++) {
        ids.push(checkedData[i].id);
      }
      return ids;
    },
    //批量查询
    getMonitorServiceProcessListData() {
      console.log("******getMonitorServiceProcessListData()")
      //获取表格数据
      const This = this;
      This.$axios.get('/lte/ems/oss/component/state', {
      }).then((response) => {
        if (response && response.data.errorCode === 'SUCCESS') {
          const result = response.data.resultVal;
          let getResult = result
          getResult.forEach(item => {
            if (item.description != "" || item.description != null || item.description != undefined) {
              item.description = this.$t(item.description);
            }
          })
          This.monitorServiceProcessData = getResult;
        }
      });
    },
    //启动服务
    doActiveTask() {
      console.log("******doActiveTask()")
      const This = this;
      const checkedData = This.getCheckedData(true);
      const list = [];
      for (let i = 0; i < checkedData.length; i++) {
        list.push({state: 1, id: checkedData[i].id, activeTime: new Date()});
      }
      let str = This.$t('Track.activation');
      if (checkedData) {
        This.$layer.confirm({
          title: this.$t('System.tip'),
          msg: `${str}?`,
          btn1: {
            msg: this.$t('Alarm.cancel')
          },
          btn2: {
            msg: this.$t('Alarm.confirm'),
            func: () => {
              This.$axios.post('/lte/ems/oss/component/updateMonitorServiceProcess', {list: list}).then((response) => {
                if (response && response.data.errorCode === 'SUCCESS') {
                  EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
                } else if (response && response.data.errorCode === '1001') {
                  EventBus.$emit('toast', {type: 'error', content: this.$t(response.data.errorString)});
                } else if (response && response.data.errorCode === '16002') {
                  EventBus.$emit('toast', {type: 'error', content: this.$t('ErrorCode.16002')});
                } else {
                  EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.error')});
                }
                This.getMonitorServiceProcessListData();
              });
            }
          }
        });
      }
    },
    //挂起服务
    doUnactiveTask() {
      console.log("******doUnactiveTask()")
      const This = this;
      const checkedData = This.getCheckedData(true);
      const list = [];
      for (let i = 0; i < checkedData.length; i++) {
        list.push({state: 0, id: checkedData[i].id, unactiveTime: new Date()});
      }
      let str = This.$t('Track.hangup');
      if (checkedData) {
        This.$layer.confirm({
          title: this.$t('System.tip'),
          msg: `${str}?`,
          btn1: {
            msg: this.$t('Alarm.cancel')
          },
          btn2: {
            msg: this.$t('Alarm.confirm'),
            func: () => {
              This.$axios.post('/lte/ems/oss/component/updateMonitorServiceProcess', {list: list}).then((response) => {
                if (response && response.data.errorCode === 'SUCCESS') {
                  EventBus.$emit('toast', {type: 'success', content: this.$t('Alarm.success')});
                } else if (response && response.data.errorCode === '1002') {
                  EventBus.$emit('toast', {type: 'error', content: this.$t(response.data.errorString)});
                } else if (response && response.data.errorCode === '16001') {
                  EventBus.$emit('toast', {type: 'error', content: this.$t('ErrorCode.16001')});
                } else {
                  EventBus.$emit('toast', {type: 'error', content: this.$t('Alarm.error')});
                }
                This.getMonitorServiceProcessListData();
              });
            }
          }
        });
      }
    },
    menuBeforeOpenFunc(menuArgs) { // 屏蔽表头的右键事件
      if (!menuArgs.rowInfo.rowIndex && menuArgs.rowInfo.rowIndex !== 0) {
        menuArgs.cancel = true;
      }
      const childList = menuArgs.element.querySelectorAll('li.e-menu-item');
      if (this.getCheckedData(true).length > 1) {
        childList[2].style.display = 'none';
      } else {
        childList[2].style.display = 'block';
      }
    },
    menuClickFunc(menuArgs) { // 为右键分配事件
      console.log("******menuArgs:", menuArgs)
      switch (menuArgs.element.innerText) {
        case `${this.$t('Alarm.refresh')}`:
          this.getMonitorServiceProcessListData();
          break;
        case `${this.$t('Monitor.systemLog.startup')}`:
          this.doActiveTask();
          break;
        case `${this.$t('Monitor.systemLog.shutdown')}`:
          this.doUnactiveTask();
          break;
        default:
      }
    }
  },
  mounted() {
    this.getMonitorServiceProcessListData();
  }
}
</script>

<style scoped>

</style>
